<template>
  <!-- TODO: 加载 进行中会话、已结束会话，并对已结束会话：质检 -->
  <div id="bd-monitor-aside">
    <div class="monitor-search">
      <el-input
        style="width: 80%;"
        size="mini"
        :placeholder="searchTip"
        suffix-icon="el-icon-search"
        v-model="search"
        clearable
      ></el-input>
      <el-button
        style="float: right;"
        size="mini"
        icon="el-icon-refresh"
        circle
        @click="refreshData()"
      ></el-button>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <el-collapse v-model="activeNames" @change="handleChange">
        <!-- 进行中 -->
        <el-collapse-item name="0">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseOngoingTitle }}</div>
          </template>
          <li
            v-for="thread in filterdThreads"
            :key="thread.tid"
            class="list-item"
            :class="{ ' active': thread.tid === userCurrentMonitorThread.tid }"
            @click.exact="selectThread(thread)"
            @click.right="rightEvent(thread)"
            @contextmenu.prevent="onContextmenu"
          >
            <div class="list-left">
              <el-badge
                v-if="thread.unreadCount > 0"
                :value="thread.unreadCount"
                :max="99"
                class="item"
              >
                <el-avatar size="medium" :src="thread.avatar"></el-avatar>
              </el-badge>
              <!-- <el-avatar v-if="thread.unreadCount === 0" size="medium" :src="thread.avatar"></el-avatar> -->
              <img
                v-if="thread.unreadCount === 0"
                class="avatar"
                width="40"
                height="40"
                :alt="thread.nickname"
                :src="thread.avatar"
              />
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">{{ thread.nickname }}</span>
                <span class="timestamp">
                  {{ thread.timestamp | time }}
                  <!-- <span v-if="thread.unreadCount !== 0" class="unreadCount">{{ thread.unreadCount }}</span> -->
                </span>
              </div>
              <div class="bottom">
                <span class="content">{{ showContent(thread) }}</span>
              </div>
              <!-- <div class="tag">
                <el-tag size="small">{{ thread.client }}</el-tag>
              </div> -->
            </div>
          </li>
          <el-empty v-if="filterdThreads.length === 0" description="空"></el-empty>
        </el-collapse-item>
        <!-- 已结束会话 -->
        <el-collapse-item name="1">
          <template slot="title">
            <div style="margin-left: 20px;">{{ collapseClosedTitle }}</div>
          </template>
          <el-empty description="开发中,惊奇期待"></el-empty>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const constants = require("@/util/constants");

export default {
  name: "bd-monitor-aside",
  data() {
    return {
      search: "",
      isLoading: true,
      activeNames: ["0"],
    };
  },
  computed: {
    ...mapGetters(["userMonitorThreads", "userCurrentMonitorThread"]),
    searchTip() {
      return this.$t("search");
    },
    filterdThreads() {
      return this.userMonitorThreads.filter((thread) => {
        return thread.nickname.includes(this.search);
      });
    },
    collapseOngoingTitle() {
      return "进行中"
    },
    collapseClosedTitle() {
      return "已结束"
    },
  },
  methods: {
    ...mapActions(["getMonitorThreads", "updateCurrentMonitorThread"]),
    refreshData() {
      // console.log("refreshData");
      // let payload = { page: 0, size: 20 }
      // this.getMonitorThreads(payload)
      this.getMonitorThreads();
    },
    selectThread(thread) {
      //
      this.updateCurrentMonitorThread(thread);
    },
    handleChange(val) {
      // console.log(val)
    },
    showContent(thread) {
      if (thread.type === constants.THREAD_TYPE_WORKGROUP) {
        return this.getClient(thread.client) + thread.content;
      }
      return thread.content;
    },
    getClient(client) {
      if (client === "web" || client === "web_pc") {
        return "[网站]";
      } else if (client === "android") {
        return "[安卓]";
      } else if (client === "ios") {
        return "[苹果]";
      } else if (client === "mp") {
        return "[公众号]";
      } else if (client === "mini") {
        return "[小程序]";
      } else {
        return "";
      }
    },
    // 鼠标右键
    rightEvent(thread) {
      // console.log('点击右键', thread)
      this.rigthSelectThread = thread;
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onContextmenu(event) {
      //
    },
  },
  created() {
    //
  },
  mounted() {
    this.refreshData();
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time(value) {
      if (typeof value === "string") {
        return moment(value).format("MM-DD HH:mm");
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped>
#bd-monitor-aside {
  width: 100%;
  height: 100%;
  float: left;
}
.monitor-search {
  padding: 12px 12px 12px 12px;
}
.list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  height: 50px;
}
.list-item:hover {
  background-color: rgb(220, 220, 220);
}
.active {
  background-color: darkkhaki;
}
.list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
li {
  list-style: none;
}
.list-left {
  margin-top: 4px;
  margin-left: 2px;
  width: 25px;
  height: 25px;
  float: left;
}
.list-right {
  margin-left: 52px;
}
.list-right .top {
  margin-top: 2px;
  text-align: left;
}
span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
span.timestamp {
  float: right;
  color: gray;
  font-size: 12px;
  vertical-align: top;
  width: 68px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .bottom {
  width: 0%;
  text-align: left;
}
.list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
.list-right .bottom .content {
  font-size: 12px;
  width: 150px;
  height: 100%;
  color: gray;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .unreadCount {
  margin-top: 4px;
  float: right;
  font-size: 10px;
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 5px;
  color: white;
  background-color: red;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
